import { Component } from "@angular/core";
import { MainService } from "core/main.service";
import { ViewService } from "core/view.service";
import { PropertyService } from "process/element/properties/property.service";
import { ProcessCollectionComponent } from "process/table/process-collection.component";

@Component({
	templateUrl: "./process-list.component.html",
	styleUrls: ["./process-list.component.scss"],
})
export class ProcessListComponent extends ProcessCollectionComponent {
	properties: unknown;

	constructor(viewService: ViewService, propertyService: PropertyService, mainService: MainService) {
		super(viewService, propertyService, mainService);
	}
}
